import React, { Component } from 'react';
import Translate from 'react-translate-component';
import Check from '../../../components/svg/check';
import LogoInvoiceWithoutCompany from '../../../components/svg/logo-invoice-without-company';

class RegisterInformation extends Component {
  render () {
    return (
      <div className='register-information'>
        <LogoInvoiceWithoutCompany colorSchema='white' />
        <ul className='perk-list'>
          <li>
            <Check colorSchema='white' />
            <Translate
              className='perk-list-item'
              content='LOGIN_REGISTER_PERK_FREE_ACCOUNT'
            />
          </li>
          <li>
            <Check colorSchema='white' />
            <Translate
              className='perk-list-item'
              content='LOGIN_REGISTER_PERK_PAPERS'
            />
          </li>
          <li>
            <Check colorSchema='white' />
            <Translate
              className='perk-list-item'
              content='LOGIN_REGISTER_PERK_WALLET'
            />
          </li>
          <li>
            <Check colorSchema='white' />
            <Translate
              className='perk-list-item'
              content='LOGIN_REGISTER_PERK_JUMPING'
            />
          </li>
          <li>
            <Check colorSchema='white' />
            <Translate
              className='perk-list-item'
              content='LOGIN_REGISTER_PERK_HEADPHONE'
            />
          </li>
        </ul>
      </div>);
  }
}

export default RegisterInformation;



/** WEBPACK FOOTER **
 ** ./src/views/register-view/tabs/register-information.js
 **/